<template>
  <card class="card-user">
    <div slot="image">
      <div style="height: 400px; width: 100%; background-color: #20a857"></div>
    </div>
    <div>
      <div class="author">
        <el-image
          style="border-radius: 50%"
          class="border-gray"
          :src="getAvatar"
          :preview-src-list="srcList"
        >
        </el-image>
        <h4 class="title mt-4">
          {{ $store.state.auth.user.first_name }}
          {{ $store.state.auth.user.last_name }}
          <br />
          <a href="#">
            <small>{{ $store.state.auth.user.username }}</small>
          </a>
        </h4>
      </div>
      <p class="description text-center">
        <span v-if="$store.state.auth.user.description">
          {{ $store.state.auth.user.description }}
        </span>
        <span v-else> "{{ $t('vie.Pag.Das.Bus.Use.UserCard.text1') }}" </span>
      </p>
    </div>
  </card>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      srcList: [],
    };
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
    }),
    getAvatar() {
      let avatar = this.$store.state.auth.user.avatar
        ? this.$store.state.auth.user.avatar
        : '/static/img/avatar-dafult.svg';
      this.srcList = [];
      this.srcList.push(avatar);
      return avatar;
    },
  },
};
</script>
<style></style>
